import React from "react";
import { TitleStyle, WrapStyle } from "./styles";
import {
  FreeTagDetailDto,
  NoneOrderTagDetailResponse,
} from "apis/data-contracts";
import DocumentTagList from "../DocumentTagList";
import FreeTagEditor from "./FreeTagEditor";

export interface CreateDocumentFormHeaderProps {
  title?: string;
  tempDocumentUuid?: string;
  docTags?: Record<string, (string | NoneOrderTagDetailResponse)[]>;
  freeTags?: FreeTagDetailDto[];
  actions?: React.ReactNode;
}
const CreateDocumentFormHeader = ({
  title,
  docTags = {},
  actions,
}: CreateDocumentFormHeaderProps) => {
  /* 렌더링될 태그 */

  return (
    <WrapStyle>
      {title && <TitleStyle>{title}</TitleStyle>}
      <DocumentTagList docTags={docTags} actions={actions} />

      <FreeTagEditor className="pc-only" />
    </WrapStyle>
  );
};

export default CreateDocumentFormHeader;
